import React from 'react';
import { ReactComponent as CheckedIcon } from '../../assets/icons/CheckedIcon.svg';
import { ReactComponent as HalfCheckedIcon } from '../../assets/icons/HalfCheckedIcon.svg';
import { RowWrapper, LeftPart, CheckBox, NameWrapper, RightPart } from './SiteRow';
import { StyledTooltip } from '../_common/StyledTooltip';
import { useTranslation } from 'react-i18next';

export type AllBtnProps = {
  totalSystemCount: number;
  selectedSystemsCount: number;
  selectedSystemGroup: string;
  filterData: any;
  filterState: any;
  isSingleSelectionMode: boolean;
  toggleAllSystemsSelection: ({}) => void;
};
const AllBtn = (props: AllBtnProps) => {
  const {
    totalSystemCount,
    selectedSystemsCount,
    selectedSystemGroup,
    filterState,
    filterData,
    isSingleSelectionMode,
    toggleAllSystemsSelection,
  } = props;
  const { t } = useTranslation();
  const getCheckedIcon = (totalCount: number, selectedCount: number) => {
    if (totalCount === selectedCount) {
      return <CheckedIcon fill="white" />;
    }
    if (selectedCount > 0 && selectedCount < totalCount) {
      return <HalfCheckedIcon fill="white" style={{ marginTop: '1px' }} />;
    }
  };
  const CheckedIconJSX = getCheckedIcon(totalSystemCount, selectedSystemsCount);
  const clickHandler = () => {
    if (!isSingleSelectionMode) {
      toggleAllSystemsSelection({ selectedSystemGroup, filterData, filterState });
    }
  };
  return (
    <>
      <StyledTooltip
        disableHoverListener={!isSingleSelectionMode}
        title={t('tooltip.xmr.singleSelection')}>
        <RowWrapper
          style={{ marginTop: '10px' }}
          data-testid="machine-filter-select-all-row">
          <LeftPart onClick={clickHandler} data-testid="all-btn-left-part">
            <CheckBox checked={selectedSystemsCount > 0} data-testid="all-btn-checkbox">
              {selectedSystemsCount > 0 && CheckedIconJSX}
            </CheckBox>

            <NameWrapper data-testid="all-btn-name">{'All'}</NameWrapper>
          </LeftPart>
          <RightPart></RightPart>
        </RowWrapper>
      </StyledTooltip>
    </>
  );
};
export default AllBtn;
